import { Paper, Table, TableContainer, TableHead, TableCell, TableBody, TableRow, Typography } from "@mui/material";

export default function Sponsor({data}){

    const find = (p,c) => {
        const item = data.find(i => i.category === c);
        return parseFloat((item && item[p]) || 0).toLocaleString();
    }

    return <>

        <Typography variant='h3'>Parrainages</Typography>

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Dentaire</TableCell>
                        <TableCell>Kiné</TableCell>
                        <TableCell>Médecine</TableCell>
                        <TableCell>Pharma</TableCell>
                        <TableCell>Santé Mentale</TableCell>
                        <TableCell>Infirmier</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>Nb parrains</TableCell>
                        <TableCell>{find('users','dentaire')}</TableCell>
                        <TableCell>{find('users','kine')}</TableCell>
                        <TableCell>{find('users','medecine')}</TableCell>
                        <TableCell>{find('users','pharma')}</TableCell>
                        <TableCell>{find('users','sante-mentale')}</TableCell>
                        <TableCell>{find('users','infirmiere')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Nb parrainages</TableCell>
                        <TableCell>{find('enrollments','dentaire')}</TableCell>
                        <TableCell>{find('enrollments','kine')}</TableCell>
                        <TableCell>{find('enrollments','medecine')}</TableCell>
                        <TableCell>{find('enrollments','pharma')}</TableCell>
                        <TableCell>{find('enrollments','sante-mentale')}</TableCell>
                        <TableCell>{find('enrollments','infirmiere')}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

    </>

}